import { render, staticRenderFns } from "./stepSum.vue?vue&type=template&id=22ff16f0&scoped=true&"
import script from "./stepSum.vue?vue&type=script&lang=js&"
export * from "./stepSum.vue?vue&type=script&lang=js&"
import style0 from "./stepSum.vue?vue&type=style&index=0&id=22ff16f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff16f0",
  null
  
)

export default component.exports